import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_URL || "https://api.lastiqo.com/api";

const SifreSifirla = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";

  const [yeniSifre, setYeniSifre] = useState("");
  const [yeniSifreTekrar, setYeniSifreTekrar] = useState("");
  const [sifreGoster, setSifreGoster] = useState(false);
  const [durum, setDurum] = useState(null); // null | "basarili" | "hata"
  const [mesaj, setMesaj] = useState("");
  const [yukleniyor, setYukleniyor] = useState(false);

  useEffect(() => {
    if (!token) {
      setDurum("hata");
      setMesaj("Geçersiz veya eksik sıfırlama linki. Lütfen tekrar şifre sıfırlama talebinde bulunun.");
    }
  }, [token]);

  const sifreGucuHesapla = (s) => {
    if (!s) return 0;
    let puan = 0;
    if (s.length >= 6) puan++;
    if (s.length >= 10) puan++;
    if (/[A-Z]/.test(s)) puan++;
    if (/[0-9]/.test(s)) puan++;
    if (/[^A-Za-z0-9]/.test(s)) puan++;
    return puan;
  };

  const guc = sifreGucuHesapla(yeniSifre);
  const gucRengi = ["#e8e8e8", "#e63946", "#f97316", "#eab308", "#22c55e", "#16a34a"][guc];
  const gucMetni = ["", "Çok Zayıf", "Zayıf", "Orta", "Güçlü", "Çok Güçlü"][guc];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!yeniSifre) { setDurum("hata"); setMesaj("Yeni şifre zorunludur."); return; }
    if (yeniSifre.length < 6) { setDurum("hata"); setMesaj("Şifre en az 6 karakter olmalıdır."); return; }
    if (yeniSifre !== yeniSifreTekrar) { setDurum("hata"); setMesaj("Şifreler eşleşmiyor."); return; }

    setYukleniyor(true);
    setDurum(null);
    try {
      const res = await fetch(`${API_URL}/auth/sifre-sifirla`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, yeniSifre }),
      });
      const data = await res.json();

      if (!res.ok) {
        setDurum("hata");
        setMesaj(data.mesaj || "Şifre sıfırlanamadı.");
        return;
      }

      setDurum("basarili");
      setMesaj(data.mesaj || "Şifreniz başarıyla güncellendi.");
      setTimeout(() => navigate("/login"), 3000);
    } catch {
      setDurum("hata");
      setMesaj("Sunucuya bağlanılamadı. Lütfen tekrar deneyin.");
    } finally {
      setYukleniyor(false);
    }
  };

  return (
    <div style={sayfaStyle}>
      <div style={kartStyle}>
        {/* Logo */}
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
            <div style={logoCircle}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="9" stroke="#fff" strokeWidth="1.5" />
                <circle cx="12" cy="12" r="3" fill="#fff" />
                <line x1="12" y1="3" x2="12" y2="7" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                <line x1="12" y1="17" x2="12" y2="21" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                <line x1="3" y1="12" x2="7" y2="12" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
                <line x1="17" y1="12" x2="21" y2="12" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </div>
            <span style={{ fontSize: "1.3rem", fontWeight: 400, color: "#1a1a2e" }}>
              LastiQo <strong style={{ color: "#e63946" }}>Lastik</strong>
            </span>
          </div>
        </div>

        {/* İkon */}
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <div style={{
            width: "64px", height: "64px", borderRadius: "50%",
            background: "linear-gradient(135deg, #fff5f5, #fde8ea)",
            border: "2px solid #fecaca",
            display: "inline-flex", alignItems: "center", justifyContent: "center",
          }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#e63946" strokeWidth="1.8">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
          </div>
        </div>

        <h1 style={{ fontSize: "1.4rem", fontWeight: 700, color: "#1a1a2e", textAlign: "center", marginBottom: "8px" }}>
          Yeni Şifre Belirle
        </h1>
        <p style={{ color: "#888", fontSize: "0.88rem", textAlign: "center", marginBottom: "28px", lineHeight: 1.6 }}>
          Güvenli bir şifre oluşturun.
        </p>

        {durum === "basarili" ? (
          <>
            <div style={bildirimStyle("#f0fdf4", "#bbf7d0", "#16a34a")}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
              </svg>
              <span>{mesaj} 3 saniye içinde giriş sayfasına yönlendiriliyorsunuz...</span>
            </div>
            <div style={{ textAlign: "center", marginTop: "16px" }}>
              <Link to="/login" style={linkStyle}>Giriş sayfasına git</Link>
            </div>
          </>
        ) : (
          <>
            {!token || durum === "hata" && mesaj.includes("Geçersiz veya eksik") ? (
              <div style={bildirimStyle("#fff5f5", "#fecaca", "#e63946")}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#e63946" strokeWidth="2.5">
                  <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                <span>{mesaj}</span>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                {/* Yeni Şifre */}
                <div style={{ marginBottom: "20px" }}>
                  <label style={labelStyle}>YENİ ŞİFRE</label>
                  <div style={{ position: "relative" }}>
                    <span style={ikonStyle}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                    </span>
                    <input
                      type={sifreGoster ? "text" : "password"}
                      value={yeniSifre}
                      onChange={(e) => { setYeniSifre(e.target.value); setDurum(null); }}
                      placeholder="En az 6 karakter"
                      style={{ ...inputStyle(durum === "hata"), paddingRight: "42px" }}
                      onFocus={(e) => e.target.style.borderColor = "#e63946"}
                      onBlur={(e) => e.target.style.borderColor = durum === "hata" ? "#e63946" : "#e8e8e8"}
                    />
                    <button type="button" onClick={() => setSifreGoster(!sifreGoster)} style={gozBtn}>
                      {sifreGoster ? (
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" />
                        </svg>
                      ) : (
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
                        </svg>
                      )}
                    </button>
                  </div>

                  {/* Şifre Güç Göstergesi */}
                  {yeniSifre && (
                    <div style={{ marginTop: "8px" }}>
                      <div style={{ display: "flex", gap: "4px", marginBottom: "4px" }}>
                        {[1, 2, 3, 4, 5].map((i) => (
                          <div key={i} style={{
                            flex: 1, height: "3px", borderRadius: "2px",
                            background: i <= guc ? gucRengi : "#e8e8e8",
                            transition: "background 0.3s",
                          }} />
                        ))}
                      </div>
                      {gucMetni && <span style={{ fontSize: "0.75rem", color: gucRengi, fontWeight: 500 }}>{gucMetni}</span>}
                    </div>
                  )}
                </div>

                {/* Şifre Tekrar */}
                <div style={{ marginBottom: "20px" }}>
                  <label style={labelStyle}>ŞİFRE TEKRAR</label>
                  <div style={{ position: "relative" }}>
                    <span style={ikonStyle}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                    </span>
                    <input
                      type={sifreGoster ? "text" : "password"}
                      value={yeniSifreTekrar}
                      onChange={(e) => { setYeniSifreTekrar(e.target.value); setDurum(null); }}
                      placeholder="Şifreyi tekrar girin"
                      style={inputStyle(durum === "hata")}
                      onFocus={(e) => e.target.style.borderColor = "#e63946"}
                      onBlur={(e) => e.target.style.borderColor = durum === "hata" ? "#e63946" : "#e8e8e8"}
                    />
                    {yeniSifreTekrar && (
                      <span style={{ position: "absolute", right: "14px", top: "50%", transform: "translateY(-50%)" }}>
                        {yeniSifre === yeniSifreTekrar
                          ? <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>
                          : <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#e63946" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        }
                      </span>
                    )}
                  </div>
                </div>

                {durum === "hata" && (
                  <div style={bildirimStyle("#fff5f5", "#fecaca", "#e63946")}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#e63946" strokeWidth="2.5">
                      <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    <span>{mesaj}</span>
                  </div>
                )}

                <button type="submit" disabled={yukleniyor} style={butonStyle(yukleniyor)}>
                  {yukleniyor ? (
                    <>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                        style={{ animation: "spin 1s linear infinite" }}>
                        <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                      </svg>
                      Kaydediliyor...
                    </>
                  ) : "Şifremi Güncelle"}
                </button>
              </form>
            )}
          </>
        )}

        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <Link to="/login" style={linkStyle}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="15 18 9 12 15 6" />
            </svg>
            Giriş sayfasına dön
          </Link>
        </div>
      </div>

      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

// ── Stiller ──────────────────────────────────────────────────────────────────
const sayfaStyle = {
  minHeight: "100vh",
  background: "linear-gradient(145deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
  display: "flex", alignItems: "center", justifyContent: "center",
  fontFamily: "'Segoe UI', sans-serif", padding: "20px",
};

const kartStyle = {
  background: "#fff", borderRadius: "20px", padding: "48px 44px",
  width: "100%", maxWidth: "440px",
  boxShadow: "0 24px 64px rgba(0,0,0,0.3)",
};

const logoCircle = {
  width: "36px", height: "36px", borderRadius: "50%",
  background: "linear-gradient(135deg, #1a1a2e 60%, #e63946)",
  display: "flex", alignItems: "center", justifyContent: "center",
};

const labelStyle = {
  display: "block", fontSize: "0.78rem", fontWeight: 600,
  color: "#444", marginBottom: "8px", letterSpacing: "0.3px",
};

const ikonStyle = {
  position: "absolute", left: "13px", top: "50%",
  transform: "translateY(-50%)", color: "#bbb",
  display: "flex", alignItems: "center",
};

const gozBtn = {
  position: "absolute", right: "14px", top: "50%",
  transform: "translateY(-50%)", background: "none",
  border: "none", cursor: "pointer", color: "#bbb",
  padding: 0, display: "flex", alignItems: "center",
};

const inputStyle = (hataVar) => ({
  width: "100%", boxSizing: "border-box",
  padding: "12px 14px 12px 38px",
  border: `1.5px solid ${hataVar ? "#e63946" : "#e8e8e8"}`,
  borderRadius: "10px", fontSize: "0.9rem", color: "#333",
  outline: "none", background: "#fafafa", transition: "border-color 0.2s",
});

const butonStyle = (disabled) => ({
  width: "100%", padding: "13px",
  background: disabled ? "#c0392b" : "linear-gradient(135deg, #e63946, #c0392b)",
  color: "#fff", border: "none", borderRadius: "10px",
  fontSize: "0.93rem", fontWeight: 600,
  cursor: disabled ? "not-allowed" : "pointer",
  display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
});

const bildirimStyle = (bg, border, color) => ({
  background: bg, border: `1px solid ${border}`, borderRadius: "10px",
  padding: "12px 16px", marginBottom: "16px", color,
  fontSize: "0.85rem", display: "flex", alignItems: "flex-start", gap: "10px",
  lineHeight: 1.5,
});

const linkStyle = {
  color: "#e63946", fontSize: "0.85rem", textDecoration: "none",
  fontWeight: 500, display: "inline-flex", alignItems: "center", gap: "6px",
};

export default SifreSifirla;
